// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Checked = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Checked = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Checked = _exports.Checked = function Checked(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      rx: "10",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.99921 13.8327C7.99855 13.8327 7.99788 13.8327 7.99721 13.8327C7.86388 13.832 7.73655 13.7787 7.64255 13.6834L4.97588 10.9754C4.78188 10.7787 4.78455 10.462 4.98121 10.268C5.17788 10.0747 5.49521 10.0767 5.68855 10.2734L8.00122 12.6227L14.3119 6.31203C14.5072 6.11669 14.8239 6.11669 15.0192 6.31203C15.2145 6.50736 15.2145 6.82405 15.0192 7.01938L8.35255 13.6861C8.25921 13.7801 8.13188 13.8327 7.99921 13.8327Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.4"
    }));
  };
});
